import React, { useState } from 'react';
import { Box, SxProps, Theme } from '@mui/material';

import DeviceMenu, { Opens } from './DeviceMenu';

type Props = {
  opens: Opens;
  sx: SxProps<Theme>;
  children: React.ReactNode;
};

const DeviceMenuButton = ({ opens, sx, children }: Props) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  return (
    <>
      <Box
        component="button"
        type="button"
        aria-haspopup="menu"
        aria-expanded={Boolean(anchor)}
        onClick={(event: React.MouseEvent<HTMLElement>) =>
          setAnchor(event.currentTarget)
        }
        sx={sx}
      >
        {children}
      </Box>
      <DeviceMenu
        anchor={anchor}
        opens={opens}
        onClose={() => setAnchor(null)}
      />
    </>
  );
};

export default DeviceMenuButton;
